import type { IconName } from '../../components/ui/Icon';
import type { GoalMetric } from '../../types/api';

export type GoalChartKey =
  | 'kwh'
  | 'm3_water'
  | 'm3_gas'
  | 'kg_general_waste'
  | 'kg_co2e'
  | 'waste_diversion_pct';

export type GoalMetricDirection = 'lower_is_better' | 'higher_is_better';

export interface GoalMetricConfig {
  label: string;
  icon: IconName;
  unit: string;
  description: string;
  color: string;
  chartKey: GoalChartKey;
  direction: GoalMetricDirection;
  displayMultiplier: number;
}

export const GOAL_METRIC_CONFIG: Record<GoalMetric, GoalMetricConfig> = {
  water_per_dish: {
    label: 'Agua por Plato',
    icon: 'water',
    unit: 'L/plato',
    description: 'Reduce el consumo de agua por plato servido',
    color: 'var(--info-600)',
    chartKey: 'm3_water',
    direction: 'lower_is_better',
    displayMultiplier: 1000,
  },
  gas_per_dish: {
    label: 'Gas por Plato',
    icon: 'gas',
    unit: 'm³/plato',
    description: 'Reduce el consumo de gas por plato servido',
    color: 'var(--warning-600)',
    chartKey: 'm3_gas',
    direction: 'lower_is_better',
    displayMultiplier: 1,
  },
  electricity_per_dish: {
    label: 'Electricidad por Plato',
    icon: 'electricity',
    unit: 'kWh/plato',
    description: 'Reduce el consumo de electricidad por plato servido',
    color: 'var(--brand-600)',
    chartKey: 'kwh',
    direction: 'lower_is_better',
    displayMultiplier: 1,
  },
  waste_per_dish: {
    label: 'Residuos por Plato',
    icon: 'waste',
    unit: 'kg/plato',
    description: 'Reduce la generación de residuos por plato servido',
    color: 'var(--accent-teal-600)',
    chartKey: 'kg_general_waste',
    direction: 'lower_is_better',
    displayMultiplier: 1,
  },
  co2e_per_dish: {
    label: 'CO₂e por Plato',
    icon: 'target',
    unit: 'kgCO₂e/plato',
    description: 'Reduce emisiones de carbono por plato servido',
    color: 'var(--neutral-600)',
    chartKey: 'kg_co2e',
    direction: 'lower_is_better',
    displayMultiplier: 1,
  },
  waste_diversion_pct: {
    label: 'Porcentaje de Desvío de Residuos',
    icon: 'recycle',
    unit: '%',
    description:
      'Aumenta el porcentaje de residuos desviados del relleno sanitario.',
    color: 'var(--success-600)',
    chartKey: 'waste_diversion_pct',
    direction: 'higher_is_better',
    displayMultiplier: 1,
  },
};
